export const getMillwrightFullName = (
  firstName?: string,
  lastName?: string,
  middleInitial?: string,
): string | null => {
  if (!firstName && !lastName) {
    return null;
  }

  if (!firstName) {
    return lastName!;
  }

  if (!lastName) {
    return firstName!;
  }

  const middle = middleInitial ? ` (${middleInitial})` : '';
  return `${firstName}${middle} ${lastName}`;
};

export const calculateAge = (birthdateStr: string): number | null => {
  const birthdate = new Date(birthdateStr);
  if (isNaN(birthdate.getTime())) {
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - birthdate.getFullYear();

  const hasHadBirthdayThisYear =
    today.getMonth() > birthdate.getMonth() ||
    (today.getMonth() === birthdate.getMonth() &&
      today.getDate() >= birthdate.getDate());

  if (!hasHadBirthdayThisYear) {
    age--;
  }

  return age;
};
